import { render, staticRenderFns } from "./workspaces.vue?vue&type=template&id=465cb9ea"
import script from "./workspaces.vue?vue&type=script&lang=js"
export * from "./workspaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports